import { useState, useEffect } from "react";
import { functions } from "../../firebase";
import styles from "./styles.module.css";
import { useLocation } from "react-router-dom";

export default function Verify() {
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState(false);
  const [done, setDone] = useState(false);
  const location = useLocation();

  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search);
      const token = params.get("token");
      const fn = functions.httpsCallable("verifyEmail");
      fn({ token: token })
        .then(res => {
          if (res.data.valid) {
            setVerified(true);
          }
          else {
            setError(res.data.err);
          }
        })
        .catch((err) => setError(err))
        .finally(() => setDone(true));
    }
    catch (err) {
      setError(err);
    }
  }, []);

  if (!done) return <div>Verifying...</div>
  if (verified) {
    return (
      <div>Your email has been confirmed</div>
    )
  }
  if (error && error.expired) {
    return (
      <div>Your token has expired. Click here to have another link sent to you</div>
    )
  }
  return <div>Your email could not be confirmed</div>
}
